"use client";

import styled from "styled-components";
import { sans as zoram, lineHeight, fontSize11, fontWeightNormal, fontWeightBold } from "@churchofjesuschrist/eden-style-constants";
import shared from "./shared";
import { jsx as _jsx } from "react/jsx-runtime";
const Container6 = styled.div.withConfig({
  componentId: "sc-ht51d3-0"
})(["font-family:", ";font-weight:", ";line-height:", ";font-size:", ";", ";& b,& strong{font-weight:", ";}"], zoram, fontWeightNormal, lineHeight, fontSize11, shared, fontWeightBold);

/**
 * `Text6` (Legal) is for text that people won't want to read, but is required legally.
 * @param {object} props - The component props
 * @param {React.ReactNode} props.children - Text content
 * @param {React.ElementType} [props.renderAs] - HTML tag or custom React element to render as
 * @returns {React.ReactElement} The Text6 component
 */
const Text6 = ({
  children,
  renderAs = "div",
  ...props
}) => /*#__PURE__*/_jsx(Container6, {
  as: renderAs,
  ...props,
  children: children
});
Text6.displayName = "Text6";
export default Text6;